"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const TabItem_1 = __importDefault(require("../styled/TabItem"));
const themeName_1 = __importDefault(require("../constants/themeName"));
const colorTypes_1 = require("../constants/colorTypes");
const TabItemText_1 = __importDefault(require("../styled/TabItemText"));
const Tab = ({ theme, children, color, value, isActive, isDisabled, isStretched, onClick, testId, ...otherProps }) => {
    const handleOnClick = (e) => {
        if (isDisabled) {
            e.preventDefault();
        }
        if (isDisabled || isActive) {
            return;
        }
        onClick?.(e, value);
    };
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(TabItem_1.default, { role: "tab", color: color, isActive: isActive, isDisabled: isDisabled, isStretched: isStretched, ...(0, oxygen_config_1.getTestAttributes)(`${testId}_TAB`), ...otherProps, onClick: handleOnClick },
            react_1.default.createElement(TabItemText_1.default, null, children))));
};
Tab.propTypes = {
    children: prop_types_1.default.node.isRequired,
    color: prop_types_1.default.oneOf([colorTypes_1.DARK, colorTypes_1.LIGHT]),
    // eslint-disable-next-line react/forbid-prop-types
    value: prop_types_1.default.any,
    isActive: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    isStretched: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    theme: prop_types_1.default.object,
    testId: prop_types_1.default.string,
};
Tab.defaultProps = {
    color: colorTypes_1.LIGHT,
    value: undefined,
    isActive: false,
    isDisabled: false,
    isStretched: false,
    onClick: undefined,
    theme: {},
    testId: 'TABS',
};
exports.default = (0, oxygen_config_1.withTheme)(Tab, themeName_1.default);
